(() => {
  const rootNodes = document.querySelectorAll('[data-mega-dynamic]');
  if (!rootNodes.length) return;

  rootNodes.forEach((root) => {
    const img = root.querySelector('[data-mega-dynamic-image]');
    const list = root.querySelector('[data-mega-dynamic-list]');
    const sub = root.querySelector('[data-mega-dynamic-sub]');
    const tpl = root.querySelector('template[data-mega-dynamic-data]');

    if (!list || !sub || !tpl) return;

    const blocks = Array.from(tpl.content.children);

    // Per-category products
    const productsTpl = root.querySelector('template[data-mega-dynamic-products]');
    const promoEl = root.querySelector('[data-mega-dynamic-promo]');
    const productBlocks = productsTpl ? Array.from(productsTpl.content.children) : [];

    const setActive = (linkEl) => {
      const allLinks = root.querySelectorAll('[data-mega-dynamic-link]');
      const index = Array.from(allLinks).indexOf(linkEl);

      allLinks.forEach(a => a.classList.toggle('is-active', a === linkEl));

      // Swap image (image mode)
      const nextSrc = linkEl.dataset.image;
      if (nextSrc && img) img.src = nextSrc;

      // Swap sub-links
      const dataBlock = blocks[index];
      if (dataBlock) sub.innerHTML = dataBlock.innerHTML;

      // Swap per-category products
      if (productBlocks.length && promoEl) {
        const catBlock = productBlocks[index];
        if (catBlock) promoEl.innerHTML = catBlock.innerHTML;
      }
    };

    const onEnter = (e) => {
      const a = e.target.closest("[data-mega-dynamic-link], [data-mega-dynamic-sublink]");
      if (!a) return;

      const nextSrc = a.dataset.image;
      if (nextSrc && img) img.src = nextSrc;

      if (a.hasAttribute("data-mega-dynamic-link")) {
        setActive(a);
      }
    };

    list.addEventListener('mouseenter', onEnter, true);
    list.addEventListener('focusin', onEnter, true);

    // init active
    const first = root.querySelector('[data-mega-dynamic-link]');
    if (first) first.classList.add('is-active');
  });
})();

// Mega menu: click + button → add to cart (no navigation)
document.addEventListener('click', (e) => {
  const plusBtn = e.target.closest('.mega-menu-dyn__plus-btn');
  if (!plusBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const card = plusBtn.closest('.mega-menu-dyn__product-card');
  const variantId = card && card.dataset.variantId;
  if (!variantId) return;

  plusBtn.style.opacity = '0.4';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  })
    .then(r => r.json())
    .then(() => {
      plusBtn.style.opacity = '';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const cartToggle = document.querySelector('[aria-controls="cart-drawer"]');
      if (cartToggle) cartToggle.click();
    })
    .catch(() => { plusBtn.style.opacity = ''; });
});
